import { __awaiter, __generator } from "tslib";
import { buildMsalConfig, fetchAuthorizationSetting, setUipConfig, setWebStoreApiConfig } from '@gn-audio/core';
import { setKnowledgeBaseApiConfig } from '@gn-audio/core/api/knowledge-base/config/actions';
import { setPricingApiConfig } from '@gn-audio/core/api/pricing/config/actions';
import { setProductCatalogueApiConfig } from '@gn-audio/core/api/product-catalogue/config/actions';
import { setSiteSettingsApiConfig } from '@gn-audio/core/api/site-settings/config/actions';
import { fetchGet } from '@gn-audio/core/common/http/fetch-get';
import angular from 'angular';
import { platformBrowserDynamic } from 'angular-ts-decorators';
import { ShellModule } from './src/Project/Shell/app';
(function () { return __awaiter(void 0, void 0, void 0, function () {
    var locale, supportProductApiConfigUrl, supportProductApiConfig, knowledgeBaseHeaders, authorizationSetting;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                locale = document.documentElement.dataset.marketLocale;
                supportProductApiConfigUrl = '/support/api/config?marketLocale=' + locale;
                return [4, fetchGet(supportProductApiConfigUrl, {}, 'same-origin')];
            case 1:
                supportProductApiConfig = _a.sent();
                setSiteSettingsApiConfig({
                    baseUrl: supportProductApiConfig.settingsServiceUrl,
                    marketLocale: supportProductApiConfig.language,
                    siteContext: supportProductApiConfig.siteContext,
                });
                knowledgeBaseHeaders = [];
                if (supportProductApiConfig.overrideOriginalRequestHost) {
                    knowledgeBaseHeaders.push(["X-Support-Site-Url", supportProductApiConfig.originalRequestHost]);
                }
                setKnowledgeBaseApiConfig({
                    baseUrl: supportProductApiConfig.knowledgeBaseServiceUrl,
                    marketLocale: supportProductApiConfig.language,
                    headers: knowledgeBaseHeaders,
                });
                return [4, fetchAuthorizationSetting()];
            case 2:
                authorizationSetting = _a.sent();
                if (authorizationSetting) {
                    setUipConfig(buildMsalConfig(authorizationSetting));
                    setWebStoreApiConfig({
                        baseUrl: authorizationSetting.webStoreAPIBaseUrl || '',
                        marketLocale: supportProductApiConfig.language,
                        siteContext: supportProductApiConfig.siteContext,
                        scopes: authorizationSetting.webStoreAPIScopes || [],
                        storage: localStorage,
                    });
                }
                return [4, setProductCatalogueApiConfig({
                        apiKey: supportProductApiConfig.productCatalogueServiceApiKey,
                        baseUrl: supportProductApiConfig.productCatalogueServiceUrl,
                        marketLocale: supportProductApiConfig.language,
                    })];
            case 3:
                _a.sent();
                return [4, setPricingApiConfig({
                        baseUrl: supportProductApiConfig.pricingServiceUrl,
                        marketLocale: supportProductApiConfig.language,
                    })];
            case 4:
                _a.sent();
                angular.module('gn.audio.support.productapi', [])
                    .constant('knowledgeApiUrl', supportProductApiConfig.knowledgeBaseServiceUrl)
                    .constant('wasThisUsefulApiUrl', supportProductApiConfig.wasThisUsefulServiceUrl)
                    .constant('productApiUrl', supportProductApiConfig.productCatalogueServiceUrl)
                    .constant('productApiKey', supportProductApiConfig.productCatalogueServiceApiKey)
                    .constant('pricingApiUrl', supportProductApiConfig.pricingServiceUrl)
                    .constant('apiLanguage', supportProductApiConfig.language)
                    .constant('settingsApiUrl', supportProductApiConfig.settingsServiceUrl)
                    .constant('siteLanguage', supportProductApiConfig.language)
                    .constant('siteContext', supportProductApiConfig.siteContext);
                platformBrowserDynamic()
                    .bootstrapModule(ShellModule, { strictDi: true });
                return [2];
        }
    });
}); })();
